<template>
	<vs-dropdown
		v-if="wasMounted"
		vs-custom-content
		vs-trigger-click
		class="cursor-pointer"
		:title="getTitle(selectedTypeVehicle) | lowerCase"
	>
		<span class="cursor-pointer flex items-center">
			<vs-icon class="ml-1" style="font-size: 2rem" :icon="getIcon(selectedTypeVehicle)"></vs-icon>
			<vs-icon class="ml-1" icon="expand_more"></vs-icon>
		</span>
		<vs-dropdown-menu
			:style="positionLeft ? positionLeft : ''"
			class="cart-dropdown dropdown-custom-left vx-navbar-dropdown"
		>
			<div class="notification-header text-center p-5 bg-success text-white">
				<h4 class="text-white bold">
					{{ $t("RoutingType.SelectMeansTransport") }}
				</h4>
				<span class="vs-table-text">{{ $t("RoutingType.SelectMeansTransportText") }}</span>
			</div>
			<component
				:is="scrollbarTag"
				ref="mainSidebarPs"
				class="scroll-area--cart-items-dropdowm p-0 mb-10"
				:settings="settings"
				:key="$vs.rtl"
			>
				<ul class="bordered-items">
					<div
						v-for="(routingType, index) in routingTypes"
						:key="index"
						@click="handleChangeRoutingType(routingType.id)"
					>
						<li class="flex justify-between px-2 py-2 notification cursor-pointer">
							<div class="flex items-start">
								<feather-icon
									v-if="validateSelectedType(routingType.id)"
									icon="CheckCircleIcon"
									:svgClasses="[`text-success`, 'stroke-current mr-1 h-6 w-6']"
								></feather-icon>
								<vs-radio v-else vs-name="radios" vs-value=""></vs-radio>
								<div class="mx-2 flex justify-between">
									<span
										class="font-medium block uppercase"
										:class="[
											{
												'text-success': validateSelectedType(routingType.id),
											},
										]"
										>{{ getName(routingType.id) }}
									</span>
								</div>
							</div>
							<vs-icon
								class="ml-1"
								:style="routingType.id === 'motorcycle' ? 'font-size: 2.5rem' : 'font-size: 2rem'"
								:icon="getIcon(routingType.id)"
							></vs-icon>
						</li>
					</div>
				</ul>
			</component>
		</vs-dropdown-menu>
	</vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
	props: {
		positionLeft: {
			type: String,
			default: "",
		},
	},
	components: {
		VuePerfectScrollbar,
	},
	data() {
		return {
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			wasMounted: false,
		};
	},
	computed: {
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		routingTypes() {
			let profileList = [
				{id: "car"},
				{id: "walk"},
				{id: "bicycle"},
				{id: "motorcycle"},
				{id: "truck"},
				{id: "scooter"},
				{id: "bus"},
			];
			switch (this.selectedRoutingType) {
				case "GMPRO":
					profileList.push({id: "unknown"});
					return profileList.filter(
						(profile) =>
							profile.id != "bicycle" &&
							profile.id != "truck" &&
							profile.id != "scooter" &&
							profile.id != "bus"
					);
				case "OPENROUTE":
					return profileList.filter(
						(profile) => profile.id != "truck" && profile.id != "scooter" && profile.id != "bus"
					);
				default:
					return profileList;
			}
		},
		selectedTypeVehicle() {
			const routing = this.$store.dispatch("moduleRoutingType/getRouting");
			routing.then((res) => {
				if (res) this.$store.commit("moduleRoutingType/SET_TYPE_VEHICLE", res.typeVehicle);
			});
			return this.$store.state.moduleRoutingType.typeVehicle;
		},
		getIcon() {
			return function (param) {
				let icon = "";
				switch (param) {
					case "car":
						icon = "local_taxi";
						break;
					case "walk":
						icon = "directions_walk";
						break;
					case "bicycle":
						icon = "directions_bike";
						break;
					case "motorcycle":
						icon = "two_wheeler";
						break;
					case "truck":
						icon = "local_shipping";
						break;
					case "scooter":
						icon = "rv_hookup";
						break;
					case "bus":
						icon = "directions_bus";
						break;
					case "unknown":
						icon = "bus_alert";
						break;
				}
				return icon;
			};
		},
		getTitle() {
			return function (param) {
				let title = "";
				switch (param) {
					case "car":
						title = this.$t("RoutingType.Transport") + " " + this.$t("Routing.Car");
						break;
					case "walk":
						title = this.$t("RoutingType.Transport") + " " + this.$t("Routing.Walking");
						break;
					case "bicycle":
						title = this.$t("RoutingType.Transport") + " " + this.$t("Routing.Bicycle");
						break;
					case "motorcycle":
						title = this.$t("RoutingType.Transport") + " " + this.$t("Routing.Motorcycle");
						break;
					case "truck":
						title = this.$t("RoutingType.Transport") + " " + this.$t("Routing.Truck");
						break;
					case "scooter":
						title = this.$t("RoutingType.Transport") + " " + this.$t("Routing.Scooter");
						break;
					case "bus":
						title = this.$t("RoutingType.Transport") + " " + this.$t("Routing.Bus");
						break;
					case "unknown":
						title = this.$t("RoutingType.Transport") + " " + this.$t("NotSpecified");
						break;
				}
				return title;
			};
		},
		getName() {
			return function (param) {
				let name = "";
				switch (param) {
					case "car":
						name = this.$t("Routing.Car");
						break;
					case "walk":
						name = this.$t("Routing.Walking");
						break;
					case "bicycle":
						name = this.$t("Routing.Bicycle");
						break;
					case "motorcycle":
						name = this.$t("Routing.Motorcycle");
						break;
					case "truck":
						name = this.$t("Routing.Truck");
						break;
					case "scooter":
						name = this.$t("Routing.Scooter");
						break;
					case "bus":
						name = this.$t("Routing.Bus");
						break;
					case "unknown":
						name = this.$t("NotSpecified");
						break;
				}
				return name;
			};
		},
		selectedRoutingType() {
			return this.$store.state.routingType;
		},
	},
	methods: {
		validateSelectedType(val) {
			return this.selectedTypeVehicle === val;
		},
		async handleChangeRoutingType(type) {
			this.$store.commit("moduleRoutingType/SET_TYPE_VEHICLE", type);
			await this.$store.dispatch("moduleRoutingType/saveTypeVehicle", type);
		},
	},
	mounted() {
		this.wasMounted = true;
	},
};
</script>
<style lang="scss" scoped>
.con-vs-dropdown--menu {
	z-index: 54000 !important;
}
</style>
